// Utility for logging Supabase CRUD operations and errors
export function logSupabaseOperation(operation: string, data: any, error: any) {
  if (error) {
    // eslint-disable-next-line no-console
    console.error(`[Supabase][${operation}] Error:`, error, 'Data:', data);
  } else {
    // eslint-disable-next-line no-console
    console.log(`[Supabase][${operation}] Success:`, data);
  }
} 